import fetch from "node-fetch"


// ---------- PARAMS -------------------------------

let cached_bsvusd = 123.21              // default fallback value
let bsvusd_update_every_ms = 10 * 60 * 1000    // update every 10 mins max

// -------------------------------------------------

let bsvusd_lastupdate = 0 // timestamp


/**
 * using a synchronous, cached version strategy for most calls
 * allows us to answer instantly to keep a fast oracle
 * and update the cache in the background asynchronously for next calls
 */
export async function get_cached_BSVUSD_price() {
    if (bsvusd_lastupdate == 0) {
        // if we never did an update, we will have to force one even if this is not ideal
        // you should call this function on launch to avoid doing it when you have to answer fast
        console.log("get_cached_BSVUSD_price(): FIRST TIME: need to update BSVUSD price")
        await update_cached_BSVUSD_price()
        bsvusd_lastupdate = Date.now()
        console.log("get_cached_BSVUSD_price(): FIRST TIME: set BSVUSD=", cached_bsvusd)
        return cached_bsvusd
    }
    else if (Date.now() - bsvusd_lastupdate > bsvusd_update_every_ms) {
        bsvusd_lastupdate = Date.now()

        console.log("get_cached_BSVUSD_price(): need to update BSVUSD price")

        // no await here to not block oracle ! we will update cache asynchronously
        update_cached_BSVUSD_price()
    }

    return cached_bsvusd
}

async function update_cached_BSVUSD_price() {
    try {
        let new_BSVUSD_price = await get_latest_BSVUSD_price()

        if (!isNaN(new_BSVUSD_price) && new_BSVUSD_price > 0) {
            console.log("update_cached_BSVUSD_price(): Update BSVUSD price from", cached_bsvusd, "to", new_BSVUSD_price)
            cached_bsvusd = new_BSVUSD_price
        }
    } catch (e) {
        console.error("Error in update_cached_BSVUSD_price(): ", e)
    }
}

export function get_latest_BSVUSD_price() {
    // strategy: if one fails we move to the next one
    // preev provides a nice volume-weighted average BUT I HAVE EXPERIENCED WRONG PRICES BY A LOT (189 instead of 121)
    // => so I decide to move it as last, 03.01.2021

    // we can check site rank using: https://www.alexa.com/siteinfo/coingecko.com
    // coingecko is 269, cryptonator is 31,832, whatsonchain 406,428, preev 5,820,430
    return new Promise((resolve, reject) => {
        console.log("fetching BSVUSD from CoinGecko...")
        get_BSVUSD_CoinGecko().then(resolve).catch(e => {
            console.log("Error while fetching BSV price from CoinGecko", e)
            console.log("fetching BSVUSD from Whatsonchain...")
            get_BSVUSD_Whatsonchain().then(resolve).catch(e => {
                console.log("Error while fetching BSV price from WhatsonChain", e)
                console.log("fetching BSVUSD from Preev...")
                get_BSVUSD_Preev().then(resolve).catch(reject)
            })
        })
    })
}



function get_BSVUSD_Preev() {

    const url = "https://api.preev.pro/v1/tickers/12eLTxv1vyUeJtp5zqWbqpdWvfLdZ7dGf8"

    return new Promise((resolve, reject) => {
        fetch(url).then(function (res) {
            if (res.status !== 200) {
                reject("Error while fetching Preev:", res.status)
                return;
            }
            return res.json()
        }).then(data => {
            if (data && data.p && data.p.ppi && data.p.ppi.l) {
                resolve(data.p.ppi.l)
            }
            reject("Error while parsing response from Preev price API, data=", data)
        }).catch(reject)
    })
}


function get_BSVUSD_CoinGecko() {
    const bsv_id = "bitcoin-cash-sv"
    const url = "https://api.coingecko.com/api/v3/simple/price?ids=" + bsv_id + "&vs_currencies=USD"

    return new Promise((resolve, reject) => {
        fetch(url).then(function (res) {
            if (res.status !== 200) {
                reject("Error while fetching CoinGecko: ", res.status);
                return;
            }
            return res.json()
        }).then(data => {
            if (data[bsv_id] && data[bsv_id]["usd"]) {
                const price = Number(data[bsv_id]["usd"]);
                if (price > 0) {
                    resolve(price)
                    return;
                }
            }
            reject("Error while parsing response from coingecko price API, data=", data);
        }).catch(reject)
    })
}

function get_BSVUSD_Whatsonchain() {
    const url = "https://api.whatsonchain.com/v1/bsv/main/exchangerate" // USD

    return new Promise((resolve, reject) => {
        fetch(url).then(function (res) {
            if (res.status !== 200) {
                reject("Error while fetching Whatsonchain: ", res.status);
                return;
            }
            return res.json()
        }).then(data => {
            if (data && data.rate) {
                resolve(data.rate)
            }
            reject("Error while parsing response from Whatsonchain price API, data=", data);
        }).catch(reject)
    })
}
